module.exports = __webpack_public_path__ + "static/media/tshirtt.8e17f0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/tshirtt.png
// module id = 59
// module chunks = 0